"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionBodyWrap = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _contactPickerTheme = require("../../contactPickerTheme");
const OptionBodyWrap = (0, _styled.default)("div")`
    align-self: center;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;

    // To ensure the content can elide.
    overflow: hidden;

    [aria-disabled="true"] & * {
        color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _contactPickerTheme.contactPickerTheme.option.disabled(themeMode);
}};
    }
`;
exports.OptionBodyWrap = OptionBodyWrap;
//# sourceMappingURL=OptionBodyWrap.js.map